<div *ngIf="visible" class="scan-gift-card-qr-code-container">
  <span>{{'Please scan QR-Code to obtain RFID gift card' | translate}}</span>
</div>
